module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAaCAYAAADSbo4CAAABFUlEQVR4AWN4qCbznyisLnv/mbaSHAOtAMgSEhxz75m2nM1jdUU9auCHWnLa/7W12VAcgs+xb81V+B6pyZyAqJX9AaKphR+pyV7576nCjnAIAfDOWIn/kbrsaaj6H0ADrgH5lyjCarLfQOY90VbUhzuEqGjUlRMERs9ZSDTJ3HilrSBBUbJQlz0DNktDzhg5jTwlBgOj6DWSnneP1WUWAelZ5GCgWa9QHDKQGOiYvy80ZXXgDnmiJttDNtaQq3ysIZdKKn6kLvMQI0QY6AoQaWRAHTLqkFGHjDpk1CGjDhl1yKhDoE2/xfTGwHbrW5DdzzTljRhgDeIBw+qy70ANc4b3BgoCD9Xlwh6ry8XQHWvIRME6bQCwhdS4lnwDKAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/icons/files-icon.png
// module id = 494
// module chunks = 0